if (!customElements.get('acdc-tabbed-images')) {
  class ACDCTabbedImages extends HTMLElement {
    connectedCallback() {
      if (this.dataset.alwaysShown !== 'true') {
        this.tabs = this.querySelectorAll('.tabbed-images__tab');
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activate(tab));
        });
      }
      this.initResultsModal();
    }

    activate(tab) {
      this.tabs.forEach((t) => t.classList.remove('is-active'));
      tab.classList.add('is-active');
    }

    initResultsModal() {
      const trigger = this.querySelector('[data-modal-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const modalId = trigger.getAttribute('data-modal-trigger');
        const modal = document.getElementById(modalId);
        if (modal && typeof modal.show === 'function') {
          modal.show(trigger);
        }
      });
    }
  }

  customElements.define('acdc-tabbed-images', ACDCTabbedImages);
}
